import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./auth";

function PrivateRoute({ component: Component, ...rest }) {
    const { isLoggedIn } = React.useContext(AuthContext);

    /**
     * Handles legacy contributor url and redirecting if url is invalid
     */
    const handleContributor = () => {

        const isContributor = window.location.pathname.split('/')[1] === 'contributor';
        if(isContributor)
        {
            if(window.location.pathname.split('/').length <5) {
                window.location.href = "/login"
            } else {
                let pieces = window.location.pathname.split('/')
                let company = parseInt(pieces[2])
                let contributor = parseInt(pieces[3])
                let token = pieces[4]

                if((company <= 0 || contributor <= 0) || token.length == 0) {
                    window.location.href = "/login"
                }
            }
        }

        if(window.location.pathname.split('/').length <5) {
            return
        }

        const isCompany = window.location.pathname.split('/')[1].toLowerCase() === 'company';
        const isAccount = window.location.pathname.split('/')[3].toLowerCase() === 'account';
        const isOldContributor = window.location.pathname.split('/')[4].toLowerCase() === "contributetosection";

        if(isCompany && isAccount && isOldContributor) {
            let pieces = window.location.search.split('&')
            if(pieces.length == 2) {
                let company = window.location.pathname.split('/')[2]
                let contributorId = pieces[0].split('=')[1]
                let token = pieces[1].split('=')[1]
                window.location.href= `/contributor/${company}/${contributorId}/${token}`
            }
        }
    }

    const isAllowedAnonymous = () => {
        handleContributor()
        const isContributor = window.location.pathname.split('/')[1] === 'contributor';
        return isContributor
    }

    return (
        <Route
            {...rest}
            render={props =>
                isAllowedAnonymous() || isLoggedIn ? (
                    <Component {...props} />
                ) : (
                        <Redirect
                            to={{ pathname: "/login", state: { referer: props.location } }}
                        />
                    )
            }
        />
    );
}

export default PrivateRoute;